import { z } from 'zod';

import { FeeId, FeeLineItemId, LosId, PaymentDueId } from '../../BrandedIds';
import { FeeStatus, FeeType } from '../../events/CreateChargeEvent';
import { InvestorRemittanceSplit } from '../../loan/InvestorRemittanceSplit';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

/**
 * One Fee <-> many FeeLineItems
 */
export const ExportableFeeLineItem = z
  .object({
    type: z.literal('fee'),
    id: zodBrandedUuid<FeeLineItemId>(),
    feeId: zodBrandedUuid<FeeId>(),
    loanId: zodBrandedString<LosId>(),

    amount: z.number(),
    lineItemType: FeeType,
    name: z.string().optional(),

    totalAmount: z.number(),
    amountRemaining: z.number(),
    status: FeeStatus,
    chargeDate: zodTemporalPlainDate,
    updatedAt: zodTemporalInstant.optional(),
    cancelledAt: zodTemporalInstant.optional(),
    comment: z.string().optional(),
    investorRemittanceSplit: InvestorRemittanceSplit.optional(),
    isDeferred: z.boolean(),
    createdAt: zodTemporalInstant.optional(),
    paymentDueId: zodBrandedUuid<PaymentDueId>().optional(),
  })
  .meta({ title: 'FeeLineItem' });
export type ExportableFeeLineItem = z.infer<typeof ExportableFeeLineItem>;
